<template>
  <div id="app" class="all-wrapper solid-bg-all">
    <router-view />
  </div>
</template>

<script>
import { getStore, setStore } from '@/config/storage'
export default {
  name: 'App',
  data() {
    return {
      timer: null,
    }
  },
  // beforeMount() {
  //   let lt = getStore('LAST_ACCESS_TIME')
  //   let userInfo = getStore('costUserInfo')
  //   //4秒未开页面
  //   if (userInfo && lt && new Date().getTime() - parseInt(lt) > 4000) {
  //     setStore('costUserInfo', '')
  //     this.$router.push('/login')
  //     return
  //   }
  // },
  // unmounted() {
  //   clearInterval(this.timer)
  // },
  // mounted() {
  //   if (this.timer) {
  //     clearInterval(this.timer)
  //   }
  //   this.timer = setInterval(function () {
  //     setStore('LAST_ACCESS_TIME', new Date().getTime())
  //   }, 2000)
  // },
}
</script>

<style lang="scss">
.el-scrollbar {
  > .el-scrollbar__bar {
    opacity: 1 !important;
  }
}
</style>
